var ComputationTypes = /* @__PURE__ */ ((ComputationTypes2) => {
  ComputationTypes2["column"] = "column";
  ComputationTypes2["segment"] = "segment";
  ComputationTypes2["metric"] = "metric";
  return ComputationTypes2;
})(ComputationTypes || {});
export {
  ComputationTypes
};
//# sourceMappingURL=MDLComputations.js.map
